import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { waitSeconds } from '@reflact/tsutil';
import { Auth } from '../services/auth';
import { TeilaufgabenCopyService } from '../routes/fallaufgaben-details/teilaufgaben-copy.service';

export const authGuard: CanActivateFn = async (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);
  const copyService = inject(TeilaufgabenCopyService);

  while (!auth.initialized) {
    // Request is automatically done, just wait for it
    await waitSeconds(0.01);
  }
  if (auth.user()) {
    return true;
  }
  copyService.clearClipboard();
  router.navigate(["/login"])
  return false;
};
